import { FC } from 'react';
import { PrivateModelModel } from '@/lib/models/private-model/private-model.model';
import PrivateModelLink from '../private-model-link';
import { UsageItem } from '../usage-card/helpers';
import UsageCard from '../usage-card';

interface Props {
  models: PrivateModelModel[];
}

const PrivateModelsCard: FC<Props> = ({ models }) => {
  const items: UsageItem[] = models.map((model) => {
    return {
      id: model.id,
      EntityLinkEl: <PrivateModelLink model={model} />,
    } as UsageItem;
  });

  return <UsageCard title="Private Models" icon="models" items={items} />;
};

export default PrivateModelsCard;
